module.exports = __webpack_public_path__ + "static/EFQM-KB-Leaflet-1bf1ded4ad03b1fa1e2983b395089ea3.pdf";